<template>
  <div class="template-profile-dropdown">
    <b-dropdown variant="white" toggle-class="text-decoration-none">
      <template #button-content>
        <span v-if="!userAvatar">{{ nameInitial }}</span>
        <img v-else class="user-avatar" :src="userAvatar" alt="" />
      </template>

      <b-dropdown-text>
        <span class="text-light d-flex justify-content-between">
          Meu progresso
        </span>
        <div class="d-flex align-items-center">
          <div class="progress mr-2">
            <div
              class="progress-bar"
              role="progressbar"
              :style="`width: ${progressPercentage}%`"
            ></div>
          </div>
          <span class="text-white">{{ progressPercentage }}%</span>
        </div>
      </b-dropdown-text>

      <b-dropdown-item :to="{ name: 'account' }">
        <i class="icon-account"></i>
        <strong class="text-white">Minha Conta</strong>
      </b-dropdown-item>
      <b-dropdown-item :to="{ name: 'support' }">
        <i class="icon-support"></i>
        <strong class="text-white">Suporte</strong>
      </b-dropdown-item>
      <b-dropdown-item @click="$emit('logout')">
        <i class="icon-logout"></i>
        <strong class="text-white">Sair</strong>
      </b-dropdown-item>
    </b-dropdown>
  </div>
</template>

<script>
import get from "lodash/get";

export default {
  computed: {
    progressPercentage() {
      return Math.round(get(this.$user.user, "progress"));
    },
    nameInitial() {
      return get(this.$user, "user.name[0]");
    },
    userAvatar() {
      return this.$user.user?.avatar;
    }
  }
};
</script>

<style lang="scss">
.template-profile-dropdown {
  .dropdown-toggle {
    max-width: 40px !important;
    max-height: 40px !important;
    min-width: 40px !important;
    min-height: 40px !important;
    border-radius: 40px !important;
    @media screen and (max-width: 575px) {
      max-width: 32px !important;
      max-height: 32px !important;
      min-width: 32px !important;
      min-height: 32px !important;
      border-radius: 32px !important;
    }
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0;
    background: white;
    font-weight: bold !important;
    font-size: 20px !important;
    color: black !important;
    border: none;

    &::after {
      display: none;
    }
  }

  .dropdown-menu {
    padding-top: 0;
    min-width: 220px;

    &.show {
      padding-bottom: 3px;
    }

    .b-dropdown-text {
      padding: 12px;
      font-weight: 700;
      margin-bottom: 0;
      font-size: 14px;
    }

    .dropdown-item {
      padding: 9px 12px;
      display: flex;
      align-items: center;
      justify-content: flex-start;
      font-size: 14px;

      i {
        width: 24px;
        margin-right: 8px;
        color: #d2d0d8;
        font-size: 20px;
      }
    }
  }

  .progress {
    width: 100%;
    height: 8px;
    border-radius: 8px;
    background: #9a9a9a;

    .progress-bar {
      border-radius: 8px;
      background: #b40409;
    }
  }
  .user-avatar {
    height: 40px;
    width: 40px;
    object-fit: cover;
    border-radius: 40px;
    @media screen and (max-width: 575px) {
      max-width: 32px !important;
      max-height: 32px !important;
      min-width: 32px !important;
      min-height: 32px !important;
      border-radius: 32px !important;
    }
  }
}
</style>
